/*@Purpose: For the Physician filter
	 * @author: bhanuwhite
	 * @ return : filter based data
	 * @Date: 6th Feb 2019
	 */
import { Pipe, PipeTransform } from '@angular/core';
import { PhysicianD } from './../models/phySearch';
@Pipe({
    name: 'PhysicianFilter'
})

export class PhysicianFilter implements PipeTransform {
    transform(physicians: PhysicianD[], searchphy: string): PhysicianD[] {
        if (!physicians || !searchphy) {
            return physicians;
        }
        return physicians.filter(phy =>
            phy.first_name.toLowerCase().indexOf(searchphy.toLowerCase()) !== -1);
    }

}
